// slider z promocjami - na podstawie Bestsellers
//@ts-nocheck
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { Grid } from '@mui/material';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';

import { useGetProducts } from 'api';
import { Loader, Container } from 'components/controls';
import ProductCard from 'components/containers/ProductCard/ProductCard';

import styles from 'theme/pages/Home/components/Promotions/Promotions.module.scss';
import promotionBannerImage from 'assets/images/promocje-banner.webp';

const Promotions: FC = () => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [canGoPrev, setCanGoPrev] = useState(false);
  const [canGoNext, setCanGoNext] = useState(false);

  // pobranie listy promocji - tak jak w Bestsellers
  const { data: promotionsData, isLoading: isPromotionsLoading } = useGetProducts({
    mode: 'PROMOTIONS',
    page: 1,
    limit: 20 // Limit produktów do wyświetlenia
  });

  const products = promotionsData?.items || [];

  const syncNavState = useCallback(() => {
    const el = sliderRef.current;
    if (!el) return;

    const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
    setCanGoPrev(el.scrollLeft > 1);
    setCanGoNext(el.scrollLeft < maxScrollLeft - 1);
  }, []);

  useEffect(() => {
    const el = sliderRef.current;
    if (!el) return;

    syncNavState();
    el.addEventListener('scroll', syncNavState, { passive: true });
    window.addEventListener('resize', syncNavState);

    return () => {
      el.removeEventListener('scroll', syncNavState);
      window.removeEventListener('resize', syncNavState);
    };
  }, [syncNavState, products.length]);

  const scrollPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -340, behavior: 'smooth' });
      window.setTimeout(syncNavState, 250);
    }
  };

  const scrollNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 340, behavior: 'smooth' });
      window.setTimeout(syncNavState, 250);
    }
  };

  // Hooki muszą być zawsze wywołane w tej samej kolejności
  if (!products.length && !isPromotionsLoading) {
    return null;
  }

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-Home-components-Promotions')}>
      <Container>
        <div className={styles.sectionTitle}>
          <span className={styles.sectionTitleText}>
            <Trans>Promocje</Trans>
          </span>
        </div>

        <Grid container spacing={2} className={styles.promotionsGrid}>
          {/* Baner po lewej na desktop, nad produktami na mobile */}
          <Grid item xs={12} md={5} className={styles.bannerColumn}>
            <div className={styles.promotionBanner}>
              <img 
                src={promotionBannerImage} 
                alt="Promocje" 
                className={styles.bannerImage}
              />
            </div>
          </Grid>

          {/* Slider z produktami po prawej na desktop, pod banerem na mobile */}
          <Grid item xs={12} md={7} className={styles.productsColumn}>
            {isPromotionsLoading && <Loader />}

            {products.length > 0 && (
              <>
                {/* Strzałki nawigacyjne nad sliderem - widoczne tylko na desktop */}
                <div className={styles.sectionNavigation}>
                  <button
                    className={classnames(
                      styles.navButton,
                      styles.back,
                      canGoPrev ? styles.active : styles.inactive
                    )}
                    onClick={scrollPrev}
                    aria-label="Poprzednie">
                    <ArrowLeft />
                  </button>
                  <button
                    className={classnames(
                      styles.navButton,
                      styles.next,
                      canGoNext ? styles.active : styles.inactive
                    )}
                    onClick={scrollNext}
                    aria-label="Następne">
                    <ArrowRight />
                  </button>
                </div>

                <div className={styles.sliderWrapper}>
                  <div className={styles.slider} ref={sliderRef}>
                    {products.map((product) => (
                      <div key={product.id} className={styles.slide}>
                        <div className={styles.productWrapper}>
                          <ProductCard product={product} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Promotions;
